module.exports = __webpack_public_path__ + "img/appledownload.fda517ff.png";